import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };

  const formatterFuction = (row, column) => {
    if (typeof Number(row[column.property]) === 'number')
      return row[column.property];
    else {
      return Number(row[column.property]) === 0
        ? '0'
        : Formatter.formatNumber(Number(row[column.property]));
    }
  };

  Table.heatColumnTable = [
    {
      prop: 'formatted_date',
      label: i18n.t('common_words.date'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'sensors_stations.station.code_station',
      minWidth: 120,
      label: i18n.t('devices.station_code'),
      fixed: true,
    },
    {
      prop: 'sensors_stations.station.name',
      label: i18n.t('devices.station'),
      minWidth: 120,
      fixed: true,
    },
    {
      prop: 'sensors_stations.sensor.two_name',
      label: i18n.t('devices.sensor'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'degreeHours',
      label: i18n.t('labor.hour_degree'),
      align: 'center',
      formatter: formatterFuction,
    },
    {
      prop: 'degreeDays',
      label: i18n.t('common_words.day_average_degree'),
      align: 'center',
      formatter: formatterFuction,
    },
    {
      prop: 'degreeDaysAcc',
      label: i18n.t('common_words.day_degree'),
      align: 'center',
      formatter: formatterFuction,
    },
  ];

  Table.calibrationTable = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'gauge_avg',
      label: i18n.t('production.general_avg'),
      align: 'center',
    },
    {
      prop: 'gauge_second_hand_avg',
      label: i18n.t('production.second_hand_avg'),
      align: 'center',
    },
    {
      prop: 'gauge_last_hand_avg',
      label: i18n.t('production.last_hand_avg'),
      align: 'center',
    },
    {
      prop: 'degree_day',
      label: i18n.t('common_words.degree_day') + ' (°C)',
      align: 'center',
    },
  ];

  Table.cuttingTable = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'totalCutting',
      label: i18n.t('production.cluster_fruit_croped'),
      align: 'center',
    },
    {
      prop: 'totalRejection',
      label: i18n.t('production.cluster_fruit_rejected'),
      align: 'center',
    },
    {
      prop: 'degree_day',
      label: i18n.t('common_words.degree_day') + ' (°C)',
      align: 'center',
    },
  ];

  Table.boxesTable = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'total_number_boxes',
      label: i18n.t('production.elaborated_boxes'),
      align: 'center',
    },
    {
      prop: 'total_number_boxes_reject',
      label: i18n.t('production.rejected_boxes'),
      align: 'center',
    },
    {
      prop: 'degree_day',
      label: i18n.t('common_words.degree_day') + ' (°C)',
      align: 'center',
    },
  ];

  Table.clustersTable = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'overgrade',
      label: i18n.t('production.overgrade'),
      align: 'center',
    },
    {
      prop: 'grade',
      label: i18n.t('production.grade'),
      align: 'center',
    },
    {
      prop: 'undergrade',
      label: i18n.t('production.undergrade'),
      align: 'center',
    },
    {
      prop: 'degree_day',
      label: i18n.t('common_words.degree_day') + ' (°C)',
      align: 'center',
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
